import { t } from "@lingui/macro";
import {
  type BillingPlanNotifications,
  BillingPlanNotificationTypeEnum,
  useResetBillingPlanNotificationsMutation,
} from "@src/__generated__/graphql";
import { Banner } from "@src/components/ui-kit";
import { onError } from "@src/utils/apollo";

interface UpdateBillingPlanProps {
  projectId: string;
  type: "date" | "budget";
  onUpdate: () => void;
  onDismiss: (data?: BillingPlanNotifications | null) => void;
}

export const UpdateBillingPlan = ({
  projectId,
  type,
  onUpdate,
  onDismiss,
}: UpdateBillingPlanProps) => {
  const [reset, { loading }] = useResetBillingPlanNotificationsMutation({
    onCompleted(data) {
      if (data) {
        onDismiss(data.resetBillingPlanNotifications?.billingPlanNotifications);
      }
    },
    ...onError(),
  });

  const onDismissWrapper = () => {
    reset({
      variables: {
        projectId,
        type:
          type === "date"
            ? BillingPlanNotificationTypeEnum.ProjectDatesChanged
            : BillingPlanNotificationTypeEnum.ProjectBudgetChanged,
      },
    });
  };

  const title =
    type === "date"
      ? t`The project date has been changed`
      : t`The budget has been changed`;

  return (
    <Banner
      size="sm"
      px="3"
      py="2"
      status="warning"
      title={title}
      description={t`Please send it to the responsible person.`}
      primaryAction={{
        title: t`Update`,
        onClick: onUpdate,
      }}
      dismissAction={{
        loading,
        onClick: onDismissWrapper,
      }}
    />
  );
};
